import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ComuneInfoDTO } from '../../shared/models/pratiche';

@Injectable({
  providedIn: 'root'
})
export class ComuniApiService {

  private baseUrl = `${environment.servicesPraticheUrl}/api/v1/public/comuni`;

  constructor(private http: HttpClient) {}

  getComuni(): Observable<ComuneInfoDTO[]> {
    return this.http.get<ComuneInfoDTO[]>(this.baseUrl);
  }
}
